/**
 * Recursively maps through an array or object
 * and calls a callback on all final value.
 * We can use it to deal with i18n objects returned from
 * the vue-i18n tm function
 *
 * @param {*} value
 * @param {*} callback
 * @returns
 */
export function deepMap(value, callback) {
  if (Array.isArray(value)) {
    return value.map((val) => deepMap(val, callback));
  } else if (typeof value === "object" && value !== null) {
    const newObj = {};
    const objKeys = Object.keys(value);

    objKeys.forEach((key) => {
      const newValue = deepMap(value[key], callback);
      newObj[key] = newValue;
    });

    return newObj;
    // We cheat a bit, and return a boolean if the value is a boolean.
    // We do this because we exclusively use this function to convert
    // language files to correct format, and boolean is already the correct format
  } else if (typeof value === "boolean") {
    return value;
  } else {
    return callback(value);
  }
}
